var SENTRY_RELEASE;SENTRY_RELEASE={name: "DoughBro", version: "1.0.0"};